<template>
    <div :class="['checkbox', className]">
        <div class="checkbox-input">
            <label v-if="showLabel && left" class="body-text" :class="{'text-dark-grey': readonly}" :for="id">{{ label }}</label>
            <input type="checkbox" :id="id" :name="name" :class="['links', className]" :disabled="readonly" v-model="localValue"
                @change="handleChange" />

            <label v-if="showLabel && !left" class="body-text" :class="{'text-dark-grey': readonly}" :for="id">{{ label }}</label>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
    props: {
        label: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        className: {
            type: String,
            default: ''
        },
        showLabel: {
            type: Boolean,
            default: true
        },
        left: {
            type: Boolean,
            default: false
        },
        modelValue: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: 'text-group'
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const localValue = ref(props.modelValue);

        const handleChange = () => {
            emit('update:modelValue', localValue.value);
            emit('change');
        };

        watch(() => localValue.value, (newValue) => {
            localValue.value = newValue;
        });

        return {
            localValue,
            handleChange
        };
    }
});
</script>